export default "__VITE_ASSET__5UAUfvOp__"